/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChevronLeftEnd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16.261 5 10 12l6.261 7L18 17.65 12.946 12 18 6.35zM6 5v14h2V5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChevronLeftEnd as ChevronLeftEnd };
